import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getAssessmentForm } from '../../../redux/actions/assessment'
import EvaluationFormWidget from '../../../widgets/evaluationForm/EvaluationFormWidget'

export default function EvaluationForm() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const assessmentId = sessionStorage.getItem('assessmentId')
  const projectCode = sessionStorage.getItem('projectCode')
  const period = sessionStorage.getItem('period')

  useEffect(() => {
    handleGetSchema(assessmentId)
  }, [assessmentId])

  const handleGetSchema = async (assessmentId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentForm(assessmentId, projectCode, null, period, null, null)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={'ตัวอย่างแบบประเมิน'} isNotCallApi />
      <EvaluationFormWidget schema={schema} isPreview={true} />
    </SidebarProposal>
  )
}
